function quarticOut(t) {
  return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0
}

module.exports = quarticOut


//////////////////
// WEBPACK FOOTER
// ./~/eases/quart-out.js
// module id = 144
// module chunks = 35783957827783 255223432971881